module.exports = __webpack_public_path__ + "img/xmas_ac_2.d4ec96c.webp";